// extracted by mini-css-extract-plugin
export default {"modal":"OpvModal_modal__WXqrO","header":"OpvModal_header__I9snN","wrapper":"OpvModal_wrapper__tYcDU","title":"OpvModal_title__1jeRw","footer":"OpvModal_footer__eyZi5"};